import StandardTable from "./view/StandardTable";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";

const Standard = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_configureagreement_standard_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <>{userPermissions.includes(viewPermission) ? <StandardTable /> : ""}</>
  );
};

export default Standard;
